import React, { Component } from 'react';
import logo from '../css/images/MBR_Transparent.png';

class Navigation extends Component {
  constructor(props){
    super(props);
    this.state = {
      view: {
        showModal: false
    
    }};
      
      this.handleHideModal = this.handleHideModal.bind(this);
      this.handleShowModal = this.handleShowModal.bind(this);
    }
    
  handleHideModal(){
    this.setState({view: {showModal: false}})
  }
  handleShowModal(){
    this.setState({view: {showModal: true}})
  }

  render() {
    return (
        <nav id="MBRNav" className="navbar navbar-expand-md navbar-light bg-light">
          <a className="navbar-brand d-inline-block align-top" href="/">
            <img id="MBRNavLogo" src={logo} height="100" alt="MBR logo"/>
          </a>
            <button className="navbar-toggler btn-sm order-first" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
            </ul>
          <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" href="#home">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#purpose-and-story">Purpose & Story</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services">Core Services</a>
              </li>
              <li className="nav-item">
                  <a className="nav-link" href="#contact">Contact</a>
                <span href="/" data-toggle="tooltip" title="info@moorebenefitresources.com">
                </span>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="client-login" rel="noopener noreferrer" target="_blank" href="https://www.thinkhr.com/hrhotline/index_client.php?broker=221937">Client Portal</a>
              </li>

              </ul>
            </div>
        </nav>      
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js